import { render, staticRenderFns } from "./CampaignData.vue?vue&type=template&id=0079b5f6&"
import script from "./CampaignData.vue?vue&type=script&lang=js&"
export * from "./CampaignData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports